import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import 'normalize.css';
import './index.css';
// import './form/fbPixel'

ReactDOM.render( < App / > ,
  document.getElementById( 'root' )
);



// WEBPACK FOOTER //
// ./src/index.js